var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusAreaReadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9993 1.33333C32.1493 0.75 30.116 0.5 28.166 0.5C24.916 0.5 21.416 1.16667 18.9993 3C16.5827 1.16667 13.0827 0.5 9.83268 0.5C6.58268 0.5 3.08268 1.16667 0.666016 3V27.4167C0.666016 27.8333 1.08268 28.25 1.49935 28.25C1.66602 28.25 1.74935 28.1667 1.91602 28.1667C4.16602 27.0833 7.41601 26.3333 9.83268 26.3333C13.0827 26.3333 16.5827 27 18.9993 28.8333C21.2493 27.4167 25.3327 26.3333 28.166 26.3333C30.916 26.3333 33.7493 26.8333 36.0827 28.0833C36.2493 28.1667 36.3327 28.1667 36.4993 28.1667C36.916 28.1667 37.3327 27.75 37.3327 27.3333V3C36.3327 2.25 35.2493 1.75 33.9993 1.33333ZM33.9993 23.8333C32.166 23.25 30.166 23 28.166 23C25.3327 23 21.2493 24.0833 18.9993 25.5V6.33333C21.2493 4.91667 25.3327 3.83333 28.166 3.83333C30.166 3.83333 32.166 4.08333 33.9993 4.66667V23.8333Z",
    fill: "url(#paint0_linear_1433_23150)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.166 10.5C29.6327 10.5 31.0493 10.65 32.3327 10.9333V8.4C31.016 8.15 29.5993 8 28.166 8C25.3327 8 22.766 8.48333 20.666 9.38333V12.15C22.5493 11.0833 25.166 10.5 28.166 10.5Z",
    fill: "url(#paint1_linear_1433_23150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.666 13.8169V16.5836C22.5493 15.5169 25.166 14.9336 28.166 14.9336C29.6327 14.9336 31.0493 15.0836 32.3327 15.3669V12.8336C31.016 12.5836 29.5993 12.4336 28.166 12.4336C25.3327 12.4336 22.766 12.9336 20.666 13.8169Z",
    fill: "url(#paint2_linear_1433_23150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.166 16.8838C25.3327 16.8838 22.766 17.3671 20.666 18.2671V21.0338C22.5493 19.9671 25.166 19.3838 28.166 19.3838C29.6327 19.3838 31.0493 19.5338 32.3327 19.8171V17.2838C31.016 17.0171 29.5993 16.8838 28.166 16.8838Z",
    fill: "url(#paint3_linear_1433_23150)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_23150",
    x1: 0.998048,
    y1: -1,
    x2: 37.998,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_23150",
    x1: 20.7717,
    y1: 7.78029,
    x2: 25.4178,
    y2: 16.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1433_23150",
    x1: 20.7717,
    y1: 12.2139,
    x2: 25.4178,
    y2: 20.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1433_23150",
    x1: 20.7717,
    y1: 16.6641,
    x2: 25.4178,
    y2: 25.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusAreaReadingIcon);
export default __webpack_public_path__ + "static/media/FocusAreaReadingIcon.90b01a8d7f9d0f9db13ecfa18ebf2273.svg";
export { ForwardRef as ReactComponent };